import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex flex-row justify-content-between pb-5" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "required" }, "SMS Template Body")
  ])
], -1)
const _hoisted_6 = { class: "d-flex justify-content-end mt-2 mb-10" }
const _hoisted_7 = { class: "badge badge-lg badge-light" }
const _hoisted_8 = { class: "card-footer d-flex flex-row justify-content-end px-0" }
const _hoisted_9 = ["data-kt-indicator"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Placeholder = _resolveComponent("Placeholder")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (!_ctx.pageLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Placeholder, {
                placeHolderOptions: _ctx.placeholders,
                onPlaceholderSelect: _ctx.handlePlaceholderSelect
              }, null, 8, ["placeHolderOptions", "onPlaceholderSelect"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Editor, {
              "output-format": "text",
              modelValue: _ctx.formData.body,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.body) = $event)),
              "api-key": _ctx.api_key,
              init: _ctx.config,
              onKeyPress: _ctx.limitInput,
              onPaste: _ctx.limitInput,
              ref: "editorInput",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleElementFocus('editorInput')))
            }, null, 8, ["modelValue", "api-key", "init", "onKeyPress", "onPaste"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.formData.body?.length ?? 0) + "/" + _toDisplayString(_ctx.max_length), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateMode ? _ctx.updateTemplate() : _ctx.createTemplate())),
              class: "btn btn-lg btn-new-design-primary fw-bolder ms-4",
              "data-kt-indicator": _ctx.formSubmitted ? 'on' : null
            }, _hoisted_12, 8, _hoisted_9)
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_el_skeleton, {
        key: 1,
        rows: 5
      }))
}